export const TIPOS_TELEFONO = [
  { id: '', descripcion: 'Seleccionar' },
  { id: 'celular', descripcion: 'Celular' },
  { id: 'fijo', descripcion: 'Fijo' },
]

export const VALIDATION_MESSAGES = {
  MIN_LENGTH_ERROR: 'Ingresá al menos dos caracteres',
  APELLIDO_REQUIRED: 'Ingresá tu apellido',
  NOMBRE_REQUIRED: 'Ingresá tu nombre',
  TIPO_TELEFONO_REQUIRED: 'Seleccioná un tipo de teléfono',
  TELEFONO_INVALID: 'Ingresá un número válido: 10 dígitos, sin 0 ni 15 al inicio',
}

export const FORM_LABELS = {
  APELLIDO: 'Apellido',
  NOMBRE: 'Nombre',
  CORREO_ELECTRONICO: 'Correo electrónico',
  TIPO_TELEFONO_PRINCIPAL: 'Tipo de teléfono principal',
  NUMERO_TELEFONO_PRINCIPAL: 'Número de teléfono principal',
  TIPO_TELEFONO_ALTERNATIVO: 'Tipo de teléfono alternativo',
  NUMERO_TELEFONO_ALTERNATIVO: 'Número de teléfono alternativo',
}

export const FORM_PLACEHOLDERS = {
  APELLIDO: 'Ingresá tu apellido',
  NOMBRE: 'Ingresá tu nombre',
  CORREO_ELECTRONICO: 'ejemplo@correo.com',
  NUMERO_TELEFONO_PRINCIPAL: 'Ingresá tu número',
  NUMERO_TELEFONO_ALTERNATIVO: 'Ej: 1122233344',
  SELECCIONAR: 'Seleccionar',
}

export const MODAL_MESSAGES = {
  SAVE_CONFIRM_TITLE: 'Guardar cambios de Perfil',
  SAVE_CONFIRM_MESSAGE:
    'Revisá que la información ingresada sea correcta. Si guardás los cambios, se actualizarán los datos de tu perfil.',
  DISCARD_TITLE: 'Descartar cambios en el perfil',
  DISCARD_MESSAGE:
    'Si los descartás, se perderán los cambios realizados y se mantendrá la información anterior de tu perfil.',
  // Copy del AC CA-06.1 de 74684: sin coma ni punto final en el mensaje.
  DELETE_TITLE_PREFIX: 'Dar de baja relación con',
  DELETE_MESSAGE: 'Si la das de baja dejarás de tener acceso a la información de esta cuenta',
  DELETE_CONFIRM_BUTTON: 'Dar de baja',
}

/** Estado con el que el service marca las solicitudes de asociación todavía no aprobadas. */
export const ESTADO_PENDIENTE = 'Pendiente'

/**
 * Rechazo de una solicitud pendiente desde Mis cuentas: motivo "Otros" del catálogo del service
 * (id 16154) con el detalle propio de este flujo. El detalle no va vacío.
 */
export const MOTIVO_RECHAZO_OTROS = {
  id: 16154,
  detalle: 'Baja de la relación solicitada por el usuario.',
}

export const TOAST_MESSAGES = {
  SUCCESS: 'Los datos de tu perfil se guardaron exitosamente',
  ERROR: 'Ocurrió un error al guardar los datos de tu perfil. Intentá nuevamente más tarde.',
  // Error genérico cuando falla (total o parcialmente) la persistencia de las
  // operaciones pendientes de cuentas al presionar "Guardar cambios"
  GUARDAR_CUENTAS_ERROR:
    'Ocurrió un error al guardar los cambios de tus cuentas. Los cambios no guardados se mantienen pendientes: intentá nuevamente.',
  // Baja de relación con una cuenta (contrato activo o solicitud pendiente)
  ELIMINAR_CUENTA_SUCCESS:
    'La relación con esta cuenta fue dada de baja correctamente. Ya no podrás acceder a su información.',
  ELIMINAR_CUENTA_ERROR: 'Ocurrió un error al dar de baja la relación. Intentá nuevamente más tarde.',
  ASOCIAR_CUENTA_SUCCESS: 'La solicitud de asociación fue enviada. Quedará pendiente de aprobación del Administrador.',
  // Escenario 2: error de negocio devuelto por el backend (ej. solicitud pendiente duplicada)
  ASOCIAR_CUENTA_ERROR_NEGOCIO: 'Esta CUIT ya se encuentra asociada a tu usuario.',
  // Escenario 2a: el CUIT ingresado no corresponde a un cliente de Provincia ART
  ASOCIAR_CUENTA_ERROR_CUIT_NO_CLIENTE: 'La CUIT ingresada no es cliente de Provincia ART.',
  // Escenario 3: error sin mensaje del backend (fallback, ej. error interno del servidor)
  ASOCIAR_CUENTA_ERROR: 'Error interno del servidor. Intentá nuevamente más tarde.',
  // Escenario 4: excepción de red / timeout
  ASOCIAR_CUENTA_ERROR_RED:
    'No pudimos conectarnos con el servidor. Revisá tu conexión e intentá nuevamente más tarde.',
  // Hints inline del campo CUIT en el modal "Asociar nueva cuenta"
  HINT_CUIT_DUPLICADA: 'Esta CUIT ya se encuentra asociada a tu usuario.',
  HINT_CUIT_NO_CLIENTE: 'La CUIT ingresada no es cliente de Provincia ART.',
  HINT_CUIT_ERROR_SERVICIO: 'No pudimos validar la CUIT. Intentá nuevamente más tarde.',
  // Textos que devuelve el backend, para mapear errores de negocio conocidos
  BACKEND_MESSAGES: {
    CUIT_NO_CLIENTE: 'La CUIT ingresada no es cliente de Provincia ART',
  },
}
